import { useMutation, useQuery } from 'react-query';
import { getCookieUser } from 'utils/auth';

import { getUser, postValidateEmail } from './services';

export function useValidateEmail() {
  return useMutation((email: string) => postValidateEmail({ email }));
}

export function useUser(options?: { userUuid?: string }) {
  const userUuid = options?.userUuid || getCookieUser()?.uuid;

  return useQuery({
    queryKey: ['user', userUuid],
    queryFn: () => getUser({ userUuid }),
    retry: 1,
  });
}
